"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var styles_1 = require("@mui/styles");
var react_i18next_1 = require("react-i18next");
var ButtonComponent_1 = __importDefault(require("../FormComponents/ButtonComponent"));
var messageTypes_1 = require("../../types/messageTypes");
var useStyles = styles_1.makeStyles(function (theme) { return styles_1.createStyles({
    success: {
        color: theme.palette.success.main,
    },
    error: {
        color: theme.palette.error.main,
    },
    warning: {
        color: theme.palette.error.main,
    },
    info: {
        color: theme.palette.primary.main,
    },
    message: {
        wordWrap: 'break-word',
    },
}); });
var DialogComponent = function (props) {
    var t = react_i18next_1.useTranslation().t;
    var classes = useStyles();
    var closingTime = props.closingTime ? props.closingTime : 3000;
    var dialogWidth = props.dialogWidth || 'auto';
    var confirmLabel = props.confirmLabel ? props.confirmLabel : t('crude:confirm');
    var cancelLabel = props.cancelLabel ? props.cancelLabel : t('crude:cancel');
    var severity = props.severity ? props.severity : messageTypes_1.Severity.info;
    var _a = react_1.useState(props.open), open = _a[0], setOpen = _a[1];
    var _b = react_1.useState(typeof (props.autoClose) === 'boolean' ? props.autoClose : true), autoClose = _b[0], setAutoClose = _b[1];
    var onClose = function () {
        props.onClose && props.onClose();
        setOpen(false);
    };
    var onConfirm = function () {
        setOpen(false);
        props.onConfirm && props.onConfirm();
    };
    var onCancel = function () {
        setOpen(false);
        props.onCancel && props.onCancel();
    };
    react_1.useEffect(function () {
        setAutoClose(typeof (props.autoClose) === 'boolean' ? props.autoClose : true);
    }, [props.autoClose]);
    react_1.useEffect(function () {
        setOpen(props.open);
        if (props.open && autoClose) {
            setTimeout(function () {
                onClose();
            }, closingTime);
        }
    }, [props.open]);
    return (react_1.default.createElement(material_1.Dialog, { open: open, onClose: function () { return onClose(); } },
        props.title && react_1.default.createElement(material_1.DialogTitle, { className: classes[severity] }, props.title),
        props.message && react_1.default.createElement(material_1.DialogContent, null,
            react_1.default.createElement(material_1.Typography, { className: classes.message }, props.message)),
        props.content && react_1.default.createElement(material_1.DialogContent, { style: { minWidth: dialogWidth } }, props.content),
        props.request &&
            react_1.default.createElement(material_1.DialogActions, null,
                props.cancelLabel !== null &&
                    react_1.default.createElement(ButtonComponent_1.default, { color: 'secondary', variant: 'text', text: cancelLabel, onClick: function () { return onCancel(); } }),
                props.confirmLabel !== null &&
                    react_1.default.createElement(ButtonComponent_1.default, { color: 'primary', variant: 'text', text: confirmLabel, onClick: function () { return onConfirm(); } }))));
};
exports.default = DialogComponent;
